import { useEffect, useState } from 'react';

import axios from 'axios';

import { useGetMyProfilePictureByIdLazyQuery } from '@school_ify/schoolify-repository/src/shared/types';

import { GET_FIRST_ELEMENT_IN_ARRAY, SERVICE_ENDPOINT } from '../utils/constants';
import studentAvatar from '../assets/student_avatar.svg';

const useGetProfilePicture = () => {
  const [getPicture, { data, loading }] = useGetMyProfilePictureByIdLazyQuery();
  const [profilePicture, setProfilePicture] = useState<string>(studentAvatar);
  const getProfilePicture = async (userId: string) => {
    getPicture({
      variables: {
        userId,
      },
      nextFetchPolicy: 'network-only',
    });
  };

  useEffect(() => {
    const bodyFormData = new FormData();

    if (loading) {
      return undefined;
    }

    if (!data) {
      return undefined;
    }

    if (!data.files.length) {
      return undefined;
    }

    bodyFormData.append('id', data.files[GET_FIRST_ELEMENT_IN_ARRAY].id);
    axios({
      method: 'post',
      url: `${SERVICE_ENDPOINT}api/file/read`,
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*' },
    }).then(response => {
      setProfilePicture(response.data.value);
    });
  }, [data]);

  return {
    getProfilePicture,
    profilePicture,
  };
};

export default useGetProfilePicture;
